import { render, staticRenderFns } from "./CreateNew.vue?vue&type=template&id=396424b6&scoped=true"
import script from "./CreateNew.vue?vue&type=script&lang=js"
export * from "./CreateNew.vue?vue&type=script&lang=js"
import style0 from "./CreateNew.vue?vue&type=style&index=0&id=396424b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_cache-loader@4.1.0_webpack@4.47.0__css-load_84b6d598d32b1da7294c0119ce301628/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396424b6",
  null
  
)

export default component.exports